import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import TextAreaInputField from "../../components/forms/TextAreaInputField";

class GiftMessageForm extends Component {

  render() {
    let {handleSubmit, submit, submitting, onCancel} = this.props;
    let submitLabel = submitting ? "Standby" : "OK"; 
    return (
      <form className="GiftMessageForm" onSubmit={handleSubmit}>
        <div className="inner">
          <Field 
            label="Message"
            name="message"
            component={TextAreaInputField}
            table={false}
            serverError={this.props.errors.message}
            />
        </div>
        <div className="buttons">
          <ActionButton label="Cancel" primary={false} onClick={onCancel} active={!submitting} />
          <ActionButton label={submitLabel} primary={true} onClick={submit} active={!submitting} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "GiftMessageForm"
})(GiftMessageForm);

export default ReduxForm;